module.exports = __webpack_public_path__ + "static/robot-delivery-site-755f55f85ec18bbdbc1f6f7b7b573af0.mp4";